import { render, staticRenderFns } from "./editParts.vue?vue&type=template&id=1298054a&scoped=true&"
import script from "./editParts.vue?vue&type=script&lang=js&"
export * from "./editParts.vue?vue&type=script&lang=js&"
import style0 from "./editParts.vue?vue&type=style&index=0&id=1298054a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298054a",
  null
  
)

export default component.exports